import home from "./home";

import cart from "./cart";

export default {
  home,

  cart,
};
